const STATUS_BADGES: Record<string, { label: string; className: string }> = {
  // PENDING: subscription/application not yet settled upstream — the balance is
  // already counted toward totals, so the badge is informational (caution state).
  PENDING: { label: 'Pendente', className: 'bg-warning-surface text-warning-text' },
  // TOTAL_WITHDRAWAL: fully redeemed; the row shows the last known balance.
  TOTAL_WITHDRAWAL: { label: 'Resgatado', className: 'bg-muted text-text-secondary' },
};

/** Self-guarding: renders nothing for ACTIVE (or unknown) statuses. */
export function InvestmentStatusBadge({ status }: { status?: string | null }) {
  const badge = status ? STATUS_BADGES[status] : undefined;
  if (!badge) return null;
  return (
    <span className={`inline-flex shrink-0 items-center rounded-full px-2 py-0.5 text-2xs font-bold uppercase ${badge.className}`}>
      {badge.label}
    </span>
  );
}

/** Banner for detail surfaces reachable by deep link after a full redemption. */
export function InvestmentWithdrawnNotice({ status }: { status?: string | null }) {
  if (status !== 'TOTAL_WITHDRAWAL') return null;
  return (
    <p className="rounded-xl bg-muted px-3 py-2 text-sm text-text-secondary">
      Posição resgatada — os valores exibem o último saldo conhecido.
    </p>
  );
}
